import SVG from './SVG'

export const LineCircleSVG = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <g className="Logo_Line">
        <g className="LINE_LOGO">
          <g className="Group">
            <path
              fill="#4CC764"
              d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
              className="Vector"
            />
            <g className="Group">
              <path
                fill="#fff"
                d="M20.003 11.301c0-3.585-3.595-6.501-8.011-6.501-4.417 0-8.011 2.917-8.011 6.501 0 3.214 2.85 5.905 6.7 6.414.26.056.616.172.706.395.08.203.052.52.026.725l-.114.685c-.035.203-.162.792.694.432.854-.36 4.613-2.716 6.293-4.65 1.162-1.274 1.718-2.566 1.718-4l-.002-.001Z"
                className="Vector"
              />
              <g className="Group">
                <path
                  fill="#4CC764"
                  d="M17.338 13.371a.153.153 0 0 0 .153-.153v-.568a.154.154 0 0 0-.153-.153h-1.53v-.59h1.53a.153.153 0 0 0 .153-.154v-.567a.154.154 0 0 0-.153-.153h-1.53v-.59h1.53a.153.153 0 0 0 .153-.154v-.567a.154.154 0 0 0-.153-.153h-2.251a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h2.25Zm-8.325 0a.153.153 0 0 0 .153-.153v-.568a.154.154 0 0 0-.153-.153h-1.53V9.722a.154.154 0 0 0-.152-.153h-.569a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h2.25Zm1.354-3.802H9.8a.153.153 0 0 0-.153.153v3.495c0 .085.069.153.153.153h.568a.153.153 0 0 0 .153-.153V9.722a.153.153 0 0 0-.153-.153Zm3.868 0h-.569a.153.153 0 0 0-.152.153v2.076l-1.6-2.16-.012-.015H11.9a.03.03 0 0 0-.009-.01l-.003-.003-.008-.007c-.002 0-.003-.002-.005-.003l-.008-.005c-.002 0-.003-.002-.005-.003l-.008-.005-.004-.002-.01-.004-.005-.001-.008-.003c-.002 0-.004 0-.006-.002l-.009-.002h-.007l-.008-.001h-.578a.153.153 0 0 0-.153.153v3.496c0 .085.068.153.153.153h.569a.153.153 0 0 0 .152-.153v-2.076l1.602 2.163a.147.147 0 0 0 .04.038l.001.002.01.006.004.002.008.004.007.003.005.001a.057.057 0 0 0 .01.003h.002a.144.144 0 0 0 .04.006h.565a.153.153 0 0 0 .153-.153V9.724a.153.153 0 0 0-.153-.153v-.002Z"
                  className="Vector"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
